$(document).ready(function() {

    /**************** Sticky Marginal Spalte ****************/
    var bottomLimiter = "";

    if ($('.ttgFixToLimiter').length) {
        bottomLimiter = ".ttgFixToLimiter";
    } else {
        bottomLimiter = ".ttgFooter";
    }

    // Initiales Erstellen des Scrolling-Verhaltens, wenn das Browserfenster > 992px ist
    if ($(window).width() > 992) {
        $(".ttgScrollAbleDiv").hcSticky({
            top: 100,
            responsive: true,
            noContainer: true,
            wrapperClassName: 'ttgMarginalSticky',
            bottomLimiter: bottomLimiter
        });
    }

    // Beim Resizen auf die Fensterbreite abprüfen und das Scrolling-Verhalten ggf. aktivieren
    $(window).resize(function() {
        if ($(window).width() > 992) {
            $(".ttgScrollAbleDiv").hcSticky({
                top: 100,
                responsive: true,
                noContainer: true,
                wrapperClassName: 'ttgMarginalSticky',
                bottomLimiter: bottomLimiter
            });
        }
    });
    /**************** // Sticky Marginal Spalte ****************/


    if ($(".ttgSubmitFilter").length) {
        $(".ttgSubmitFilter").click(function() {
            $(".ttgMobileFilterungWrapper").animate({
                "opacity": 0.1
            });
            $(".ttgListDoNotShowWhenChangeFilterHasBeenClicked").animate({
                "opacity": 0.1
            });
            $(".ttgAjaxContentWrapperLoading").show();
            $("#ttgRbContentWrapper").animatescroll();
            $("#filterForm").submit();
            //$(".ttgListDoNotShowWhenChangeFilterHasBeenClicked").fadeIn("slow");
            //$('.ttgMobileFilterungWrapper').hide();
        });
    }

    if ($(".ttgTopFilter").length) {
        $(".ttgTopFilter").click(function() {
            $(".ttgSubmitFilter").trigger('click');
        });
    }

    $(".ttgFilterClose a").click(function() {
        $(".ttgListDoNotShowWhenChangeFilterHasBeenClicked").show();
        $('.ttgMobileFilterungWrapper').hide().removeClass("ttgMobileFilterungActive");
        $('.ttgFilterTeaser').show();
        $('.ttgTourdataNoResultsInfoText').show();
        $('.ttgFilterClose').hide();
    });

    /* Beim Klick auf den "Filter ändern"-Button */
    $('#ttgFilterAendern').click(function() {
        $(".ttgListDoNotShowWhenChangeFilterHasBeenClicked").hide();
        $('.ttgFilter').children().appendTo('.ttgMobileFilter');
        $('.ttgMobileFilterungWrapper').show().addClass("ttgMobileFilterungActive");
        $('.ttgFilterTeaser').hide();
        $('.ttgTourdataNoResultsInfoText').hide();
        $('.ttgFilterClose').show();
    });

    /* FILTER VERANSTALTUNGEN */
    // Sofern Monat ausgewählt wurde muss sich das von Datum ändern
    $("#monat").change(function() {
        setVonBisDates();
    });

    // sofern Jahr ausgewählt wurde muss sich das von Datum ändern
    $("#jahr").change(function() {
        setVonBisDates();
    });

    // die Kalender Buttons klickbar machen
    if ($(".ttgCalendarIcon").length > 0) {
        $(".ttgCalendarIcon").click(function() {
            $(this).prev().find('input').trigger('focus');
        });
    }


    // Regionsfilterung - Liste
    if ($("#selectRegionsFilter").length) {
        $("#selectRegionsFilter").change(function() {
            $("#regionsFilterForm").submit();
        });
    }

    /* UMKREIS-SUCHE */
    if ($("#sliderUmkreisWrapper").length) {
        // den Startvalue ermitteln falls das Formular schon mal abgeschickt wurde
        var startValue = 10;
        if ($("#sliderUmkreis").attr('data-umkreisKMDefault')) {
            startValue = $("#sliderUmkreis").attr('data-umkreisKMDefault');
        }
        if ($("#sliderUmkreisWrapper").attr("data-umkreisSlider") > 0) {
            startValue = $("#sliderUmkreisWrapper").attr("data-umkreisSlider");
        }
        $("#sliderUmkreis").slider({
            range: "min",
            value: startValue,
            min: 0,
            max: 100,
            slide: function(event, ui) {
                if (ui.value == 0) {
                    ui.value = 1;
                }
                $("#umkreis").val("0 - " + ui.value + " km");
            }
        });

        $("#umkreis").val("0 - " + $("#sliderUmkreis").slider("value") + " km");
        if ($("#sliderUmkreisWrapper").css("display") == "none") {
            $("#umkreis").val('');
        }

        // Umkreissuche deaktivieren bei Klick auf deaktivieren
        $("#umkreisSucheDeaktivieren").click(function() {
            $("#sliderUmkreisWrapper").hide();
            $("#umkreis").val('');
        });
    }

    // Bei den normalen Input Feldern ebenfalls den Default Text onFocus rausloeschen
    $(".ttgInputFilterField").focus(function() {
        if ($(this).next().hasClass('inputFilterDefaultText') && $(this).next().val() == $(this).val()) {
            $(this).val('');
        }
    });

    // Bei den normalen Input Feldern ebenfalls den Default Text onFocus rausloeschen
    $(".ttgInputFilterField").blur(function() {
        if ($(this).next().hasClass('inputFilterDefaultText') && $(this).val() == "") {
            $(this).val($(this).next().val());
        }
    });


    // in die Filterfunktion rechts das Select kopieren, damit es mit den anderen Parametern abgeschickt werden kann
    if ($("#filterForm").length) {
        // html für hidden input name = sortParams erzeugen
        var hiddenSortParams = '<input type="hidden" name="sortParams" id="sortParamsClone" value="" />';
        $("#filterForm").append(hiddenSortParams);

        var delayTimer = (function() {
            var timer = 0;
            return function(callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })();
        // schon beim Laden der Seite das input Feld befüllen, damit der aktuelle Parameter auch immer mitgeschickt wird
        delayTimer(function() {
            $("#sortParamsClone").val($("#sortParams").val());
        }, 1000);
    }

    $("#sortParams").change(function() {
        //alert($(this).val());
        $("#sortParamsClone").val($(this).val());
        $("#filterForm").submit();
        //alert($("#sortParamsClone").val());
    });

    /********** RESET FILTERS **********/

    // Regionsdropdown für die Filterung rechts
    $("#ttgRegionenDropDown").on("change", function() {
        if ($("#ttgOrtsDropDown").length) {
            var baseURL = $('base').attr('href');
            $.ajax({
                url: baseURL + '/fileadmin/templates/global/php_scripts/ajax/orte.php',
                type: 'POST',
                data: "GebieteId=" + $(this).val() + "&lang=" + $("#ttgSpecialData").attr('data-actLanguage') + "&experienceId=" + $(this).attr("data-defaultExperienceId") + "&predefinedOrteFilter=" + $(this).attr("data-predefinedOrteFilter") + "&predefinedRegionenFilter=" + $(this).attr("data-predefinedRegionenFilter") + "&ortAuswaehlenText=" + $(this).attr("data-ortAuswaehlenText"),
                beforeSend: function() {
                    $("#ttgAjaxOrteLoader").show();
                },
                success: function(res) {
                    $("#ttgOrtsDropDown").html(res);
                    $("#ttgOrtsDropDown").next().val($("#ortsDropDownBitteAuswaehlenText").val());
                    $("#ttgAjaxOrteLoader").hide();
                },
                error: function() {
                    $("#ttgAjaxOrteLoader").hide();
                }
            });
        }
    });


    // Ortsdropdown für die Filterung rechts
    if ($("#ttgOrtsDropDown").length) {
        $("#ttgOrtsDropDown").change(function() {
            if ($(this).val() != "-1") {
                if ($("#sliderUmkreisWrapper").length) {
                    $("#sliderUmkreisWrapper").show();
                    var startValue = 10;
                    if ($("#sliderUmkreis").attr('data-umkreisKMDefault')) {
                        startValue = $("#sliderUmkreis").attr('data-umkreisKMDefault');
                    }
                    $("#umkreis").val("0 - " + startValue + " km");
                }
            } else {
                if ($("#sliderUmkreisWrapper").length) {
                    $("#sliderUmkreisWrapper").hide();
                }
            }
        });
    }



});

function toggleResetFilter(elem, className, callerElement) {
    if (window.console) { // wenn console vorhanden ist - callerElement als Debug info ausgeben
        //console.log(callerElement);
    }
    $(elem).parent().removeClass(className);
}

function setVonBisDates() {
    $("#von").val("01." + $("#monat").val() + "." + $("#jahr").val());
    var lastDayOfMonth = (getDaysInMonth($("#jahr").val(), $("#monat").val()));
    $("#bis").val(lastDayOfMonth + "." + $("#monat").val() + "." + $("#jahr").val());
}

function getDaysInMonth(iFullYear, iMonth) {
    iMonth = iMonth - 1;
    var iDaysInMonth = 32 - new Date(iFullYear, iMonth, 32).getDate();
    return iDaysInMonth;
}

function checkEnter(e, formId) {
    if (e.keyCode == 13) {
        if (formId == "filterForm") {
            $("#" + formId).submit();
        } else {
            e.preventDefault();
        }
    }
}

$(window).resize(function() {
    $(".ttgFilterAccordionContent").show();

    if ($(window).width() >= 992) {
        $(".ttgMobileFilter").children().appendTo('.ttgFilter');
        $(".ttgListDoNotShowWhenChangeFilterHasBeenClicked").show();
        $('.ttgMobileFilterungWrapper').hide();
    }
    if ($(window).width() < 992) {
        if ($(".ttgMobileFilterungWrapper").hasClass("ttgMobileFilterungActive")) {
            //$(".ttgFilterClose").show();
            $(".ttgListDoNotShowWhenChangeFilterHasBeenClicked").hide();
            $('.ttgFilter').children().appendTo('.ttgMobileFilter');
            $('.ttgFilterTeaser').hide();
            $('.ttgTourdataNoResultsInfoText').hide();
            $('.ttgMobileFilterungWrapper').show();
        }
    }
    if ($(window).width() < 768) {
        $(".ttgFilterAccordion .ttgFilterAccordionGroupHeadline").each(function() {
            if ($(this).children().hasClass("ttgFilterGroupArrowUp")) {
                $(this).next().show();
            } else {
                $(this).next().hide();
            }
        });
        // in der mobilen Auflösung müssen die Kategorie Accordions erstellt werden
        // Filter Accordions in der xs Ansicht togglen -> vorher muss der Click unbinded werden, sonst würde bei jedem resize ein neuer click Listener erstellt werden und damit würde das Accordion unzählige Male slideTogglen
        $(".ttgFilterAccordionGroupHeadline").unbind("click").click(function() {
            if ($(this).find(".ttgFilterGroupArrowDown")) {
                $(this).find(".ttgFilterGroupArrow").removeClass("ttgFilterGroupArrowDown").addClass("ttgFilterGroupArrowUp");
            }
            if ($(this).find(".ttgFilterGroupArrowUp") && $(this).next().css("display") == "block") {
                $(this).find(".ttgFilterGroupArrow").removeClass("ttgFilterGroupArrowUp").addClass("ttgFilterGroupArrowDown");
            }
            $(this).next().slideToggle("slow", function() {});
        });
    }


});